/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Rules_IntroInputs */

const en_directory_submit_rules_intro = /** @type {(inputs: Directory_Submit_Rules_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We curate real AI products that are useful to makers, builders, and teams. Please submit the main product site and keep these guidelines in mind:`)
};

const zh_directory_submit_rules_intro = /** @type {(inputs: Directory_Submit_Rules_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们收录对创作者、开发者和团队有实际帮助的 AI 产品。请提交产品主站，并注意以下规则：`)
};

/**
* | output |
* | --- |
* | "We curate real AI products that are useful to makers, builders, and teams. Please submit the main product site and keep these guidelines in mind:" |
*
* @param {Directory_Submit_Rules_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_rules_intro = /** @type {((inputs?: Directory_Submit_Rules_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Rules_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_rules_intro(inputs)
	return zh_directory_submit_rules_intro(inputs)
});
export { directory_submit_rules_intro as "directory.submit.rules_intro" }